export default __webpack_public_path__ + "static/media/face_scanner.5069e94c.png";